/**
 * Page « Messagerie » du dashboard client (/dashboard/messages).
 *
 * Stub : la messagerie interne n'est pas encore branchée à une API.
 * Renvoie l'utilisateur vers l'onglet Assistance et le formulaire contact.
 */
import { MessageSquare } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { DashboardLayout } from '@/components/dashboard/dashboard-layout';

export function DashboardMessagesPage() {
  return (
    <DashboardLayout title="Messagerie">
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <MessageSquare className="h-5 w-5 text-bcl-blue" />
            Messagerie interne
          </CardTitle>
          <CardDescription>
            Échangez directement avec votre conseiller BCL Telecom.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-3">
          <p className="text-sm text-gray-700">
            La messagerie interne arrive bientôt. En attendant, pour toute
            question sur votre dossier, utilisez l&apos;onglet{' '}
            <strong>Assistance</strong> ou contactez-nous directement.
          </p>
          <div className="flex flex-wrap gap-2">
            <Button asChild>
              <Link to="/dashboard/assistance">Ouvrir l&apos;assistance</Link>
            </Button>
            <Button asChild variant="outline">
              <Link to="/contact">Nous contacter</Link>
            </Button>
          </div>
        </CardContent>
      </Card>
    </DashboardLayout>
  );
}
